import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button } from "react-bootstrap";
import { Tooltip } from "react-tooltip";

interface IconButtonState {
  onClickButton?: any;
  tooltipText: string;
  icon: any;
  color?: string;
  disabled?: boolean;
}

const IconEmbeddedButton = ({ onClickButton = null, tooltipText, icon, color = "tertiary", disabled = false }: IconButtonState) => {
  return (
    <>
      <Button
        data-tooltip-id="tooltip"
        data-tooltip-content={tooltipText}
        className={
          color === "primary"
            ? "app-primary-color button button-smaller d-flex justify-content-center align-items-center"
            : color === "secondary"
            ? "app-secondary-color button button-smaller d-flex justify-content-center align-items-center"
            : color === "danger"
            ? "app-danger-color button button-smaller d-flex justify-content-center align-items-center"
            : color === "tertiary-inverse"
            ? "app-tertiary-color-inverse button button-smaller d-flex justify-content-center align-items-center"
            : color === "inspection-page"
            ? "app-primary-color me-2 button rounded"
            : "app-tertiary-color button button-smaller d-flex justify-content-center align-items-center"
        }
        onClick={onClickButton}
        disabled={disabled}
      >
        <FontAwesomeIcon icon={icon} />
      </Button>
      <Tooltip id="tooltip" place="top" style={{ padding: "5px 10px" }} />
    </>
  );
};

export default IconEmbeddedButton;
